/**
 *
 * @license Royal Canin
 * @contributors :
 *  - Amar YASSA
 */

import { ShareRecommendationData } from '@app/core/models/share-recommendation-data';
import { createAction, props } from '@ngrx/store';

export const SET_SHARE_RECOMMENDATION = '[SHARE RECOMMENDATION] set share recommendation';
export const RESET_SHARE_RECOMMENDATION = '[SHARE RECOMMENDATION] reset share recommendation';

export const setShareRecommendation = createAction(SET_SHARE_RECOMMENDATION, props<{ data: ShareRecommendationData }>());
export const resetShareRecommendation = createAction(RESET_SHARE_RECOMMENDATION);
